import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#373877',
        success: colors.green.accent4,
        error: colors.red.darken1,
        warning: colors.orange.accent4,
        backgroundDesktop: colors.grey.lighten5,
        backgroundMobile: '#FFFFFF',
        tileMobile: '#F1F3F5',
        tileDesktop: '#FFFFFF',
      },
    },
  },
})

export default vuetify
